import { NgModule } from '@angular/core';
import {
  AnonymousConsentsModule,
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideFeatureToggles,
  UserModule,
  UserOccModule,
} from '@spartacus/core';
import {
  AnonymousConsentManagementBannerModule,
  AnonymousConsentsDialogModule,
  BannerCarouselModule,
  BannerModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  MyAccountV2Module,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PageTitleModule,
  PaymentMethodsModule,
  PDFModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductListingPageModule,
  ProductPageEventModule,
  ScrollToTopModule,
  StockNotificationModule,
  VideoModule,
} from '@spartacus/storefront';
import { UserFeatureModule } from './features/user/user-feature.module';
import { CartBaseFeatureModule } from './features/cart/cart-base-feature.module';
import { CartSavedCartFeatureModule } from './features/cart/cart-saved-cart-feature.module';
import { WishListFeatureModule } from './features/cart/wish-list-feature.module';
import { CartQuickOrderFeatureModule } from './features/cart/cart-quick-order-feature.module';
import { CartImportExportFeatureModule } from './features/cart/cart-import-export-feature.module';
import { OrderFeatureModule } from './features/order/order-feature.module';
import { CheckoutFeatureModule } from './features/checkout/checkout-feature.module';
import { PersonalizationFeatureModule } from './features/tracking/personalization-feature.module';
import { PdfinvoicesModuleFeatureModule } from './features/pdf-invoices/pdfinvoices-module-feature.module';
import { RequestedDeliveryDateModuleFeatureModule } from './features/requested-delivery-date/requested-delivery-date-module-feature.module';
import { OrganizationUserRegistrationFeatureModule } from './features/organization/organization-user-registration-feature.module';
import { OrganizationAdministrationFeatureModule } from './features/organization/organization-administration-feature.module';
import { OrganizationAccountSummaryFeatureModule } from './features/organization/organization-account-summary-feature.module';
import { OrganizationUnitOrderFeatureModule } from './features/organization/organization-unit-order-feature.module';
import { OrganizationOrderApprovalFeatureModule } from './features/organization/organization-order-approval-feature.module';
import { StoreFinderFeatureModule } from './features/storefinder/store-finder-feature.module';
import { AsmFeatureModule } from './features/asm/asm-feature.module';
import { AsmCustomer360FeatureModule } from './features/asm/asm-customer360-feature.module';
import { S4omFeatureModule } from './features/s4om/s4om-feature.module';
import { SmartEditFeatureModule } from './features/smartedit/smart-edit-feature.module';
import { ProductVariantsFeatureModule } from './features/product/product-variants-feature.module';
import { ProductImageZoomFeatureModule } from './features/product/product-image-zoom-feature.module';
import { ProductBulkPricingFeatureModule } from './features/product/product-bulk-pricing-feature.module';
import { StyleGuideModule } from './features/style-guide/style-guide.module';
import { CustomSiteContextSelectorModule } from './features/misc/site-context-selector/site-context-selector.module';
import { SearchBoxByModalModule } from './features/misc/search-box-by-modal/search-box-by-modal.module';
import { CustomSearchBoxModule } from './features/misc/search-box-by-modal/search-box/search-box.module';
import { CustomCategoryNavigationModule } from './features/store-front/misc/category-navigation/category-navigation.module';
import { CustomBreadcrumbModule } from './features/misc/breadcrumb/breadcrumb.module';
import { CustomProductIntroModule } from './features/product/product-intro/product-intro.module';
import { CustomProductFacetNavigationModule } from './features/product/product-list/product-facet-navigation/product-facet-navigation.module';
import { CustomProductListModule } from './features/product/product-list/product-list.module';
import { CustomProductTabsModule } from './features/product/product-tabs/product-tabs.module';
import { CustomTabParagraphContainerModule } from './features/store-front/misc/cms-components/tab-paragraph-container/tab-paragraph-container.module';
import { ModelUpdateModule } from '../core/models/_model-update.module';
import { AccountSelectionModule } from './features/user/account/components/login-form/account-selection/account-selection.module';
import { CustomLogoutModule } from './features/user/logout/logout.module';
import { CustomHandlerModule } from '../core/handlers/handlers.module';
import { ProductShortcutFeaturesModule } from './features/product/product-shortcut-features/product-shortcut-features.module';
import { ProductKeyFeatureModule } from './features/product/product-key-feature/product-key-feature.module';
import { CustomProductSummaryModule } from './features/product/product-summary';
import { ProductCompareCheckModule } from './features/product/product-comparator-check/product-compare-check.module';
import { ModifyMotorsModule } from './features/product/modify-motors/modify-motors.module';
import { WhereToBuyModule } from './features/product/where-to-buy/where-to-buy.module';
import { ContactOurExpertsModule } from './features/product/contact-our-experts/contact-our-experts.module';
import { CheckInventoryModule } from './features/product/check-inventory/check-inventory.module';
import { ProductPriceModule } from './features/product/product-price/product-price.module';
import { OverrideSpartacusServicesModule } from '../core/services/_override-spartacus-services.module';
import { ProductNameModule } from './features/product/product-name/product-name.module';
import { SimpleGalleryModule } from './features/product/simple-gallery/simple-gallery.module';
import { ResourceCenterContainerModule } from './features/product/resource-center-container/resource-center-container.module';
import { ProductSpecificationsModule } from './features/product/product-specifications/product-specifications.module';
import { ProductEfficiencyModule } from './features/product/product-efficiency/product-efficiency.module';
import { ProductInventoryModule } from './features/product/product-inventory/product-inventory.module';
import { ContentPagesModule } from './features/content-pages/content-pages.module';
import { CustomProductReferencesModule } from './features/store-front/misc/cms-components/product/product-references/product-references.module';
import { QuotesModule } from './features/quotes/quotes.module';
import { ReportsModule } from './features/reports/reports.module';
import { QuotesHistoryModule } from './features/quotes/quotes-history/quotes-history.module';
import { ProductCrossReferenceModule } from './features/product-cross-reference/product-cross-reference.module';
import { ProductComparatorFloattingModule } from './features/product/product-comparator-floating/product-comparator.module';
import { ProductComparatorModule } from './features/product/product-comparator/product-comparator.module';
import { InvoicesModule } from './features/invoices/invoices.module';
import { InvoiceDetailsModule } from './features/invoices/invoice-details/invoice-details.module';
import { ShipmentsModule } from './features/shipments/shipments.module';
import { ReturnsModule } from './features/returns/returns.module';
import { ReturnDetailsModule } from './features/returns/return-details/return-details.module';
import { ProductAuxModule } from './features/product/product-aux.module';
import { ApprovalsPageModule } from './features/approvals-page/approvals-page.module';
import { ContactOurExpertsHiddenModule } from './features/misc/contact-our-experts-hidden/contact-our-experts-hidden.module';
import { DashboardModule } from './features/dashboard/dashboard.module';
import { PriceMediaModule } from './features/price-media/price-media.module';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    CustomLogoutModule, //LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    CustomTabParagraphContainerModule, //TabParagraphContainerModule,
    BannerCarouselModule,
    CustomCategoryNavigationModule, // CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    CustomBreadcrumbModule, // BreadcrumbModule,
    ScrollToTopModule,
    PageTitleModule,
    VideoModule,
    PDFModule,
    UserModule,
    UserOccModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    MyAccountV2Module,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    AnonymousConsentsModule.forRoot(),
    AnonymousConsentsDialogModule,
    AnonymousConsentManagementBannerModule,
    ProductModule.forRoot(),
    ProductAuxModule,
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    CustomProductListModule, // ProductListModule,
    CustomSearchBoxModule, // SearchBoxModule,
    CustomProductFacetNavigationModule, // ProductFacetNavigationModule,
    CustomProductTabsModule, // ProductTabsModule,
    ProductCarouselModule,
    ProductNameModule,
    CustomProductReferencesModule,
    ProductShortcutFeaturesModule,
    ProductKeyFeatureModule,
    ProductCompareCheckModule,
    ModifyMotorsModule,
    WhereToBuyModule,
    ContactOurExpertsModule,
    CheckInventoryModule,
    ProductInventoryModule,
    ProductPriceModule,
    // ProductImagesModule,
    SimpleGalleryModule,
    CustomProductSummaryModule,
    ResourceCenterContainerModule,
    ProductSpecificationsModule,
    ProductEfficiencyModule,
    CustomProductIntroModule, // ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    CartBaseFeatureModule,
    CartSavedCartFeatureModule,
    WishListFeatureModule,
    CartQuickOrderFeatureModule,
    CartImportExportFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    PdfinvoicesModuleFeatureModule,
    RequestedDeliveryDateModuleFeatureModule,
    OrganizationUserRegistrationFeatureModule,
    OrganizationAdministrationFeatureModule,
    OrganizationAccountSummaryFeatureModule,
    OrganizationUnitOrderFeatureModule,
    OrganizationOrderApprovalFeatureModule,
    StoreFinderFeatureModule,
    AsmFeatureModule,
    AsmCustomer360FeatureModule,
    S4omFeatureModule,
    // CdcFeatureModule,
    SmartEditFeatureModule,
    ProductVariantsFeatureModule,
    ProductImageZoomFeatureModule,
    ProductBulkPricingFeatureModule,

    StyleGuideModule,
    CustomSiteContextSelectorModule,
    SearchBoxByModalModule,
    ModelUpdateModule,
    AccountSelectionModule,
    CustomHandlerModule,
    OverrideSpartacusServicesModule,
    ContentPagesModule,
    QuotesHistoryModule,
    ReportsModule,
    QuotesModule,
    ProductCrossReferenceModule,
    ProductComparatorFloattingModule,
    ProductComparatorModule,
    InvoicesModule,
    InvoiceDetailsModule,
    ShipmentsModule,
    ReturnsModule,
    ReturnDetailsModule,
    ApprovalsPageModule,
    ContactOurExpertsHiddenModule,
    DashboardModule,
    PriceMediaModule,
  ],
  providers: [
    provideFeatureToggles({
      removeDuplicatedOrderHistoryHeader: true,
      enableB2BUnitSearch: true,
      enableB2BCostCenterSearch: true,
      enableB2BCustomerSearch: true,
      enableMediaPrefix: true,
      showOnlyActiveCurrencies: true,
      useEnhancedSecurePasswordValidators: true,
      enableRemoveVoucherEndpoint: true,
      showRequiredAsterisks: true,
      enableExpiredRefreshTokenHandlers: true,
      productListItemSummaryReadMore: true,
      showSortFieldsOnlyAtTop: true,
      enableCartReloadOnContextChange: true,
      opfPaymentVerificationCheckProcessingCartOnErrorOnly: true,
      authorizationCodeFlowByDefaultCsrfTokenRefresh: true,
      searchBoxRecentSearchesRemoval: true,
      cdsBottomHeaderSlotAdjustPosition: true,
      redirectOnlyOnTrueNavigationEnd: true,
      pageLinkSanitizeCanonicalUrl: true,
      opfUseDestroyRef: true,
      enableHierarchicalAddressFormat: true,
      opfCheckoutUseUpdatePaymentTransaction: true,
      propagateLogoutToAllTabs: true,
      asyncAuthConfigInitializer: true,

      a11yNgSelectUnicodeCarets: true,
      a11yFutureStockAccordionAriaControls: true,
      a11yStoreFinderLabel: true,
      a11yAddPaddingToCarouselPanel: true,
      a11yKeyboardAccessibleZoom: true,
      a11yPreventCartItemsFormRedundantRecreation: true,
      a11yLinkBtnsToTertiaryBtns: true,
      a11yCustomerTicketingVisualFocusFix: true,
      a11yCardNotificationMessage: true,
      a11yFacetFilterByLabel: true,
      a11yCarouselPreventNavigationFocus: true,
      a11yNgSelectReadonlyInputValue: true,
      a11yPasswordVisibilityToggle: true,
      a11yAddedToCartDialogHeading: true,
      a11yListSemanticsForFacets: true,
      a11yCartItemListHideEmptyOutlets: true,
      a11yReviewsKeyboardControls: true,
      a11yCartQuickOrderFormEnableSubmitAndAddValidation: true,
      a11yConsentManagementFocusPreservation: true,
      a11yVocalizeDropdownItemCount: true,
      alignNavigationMenuWithHeader: true,
      a11yB2BRegisterComponent: true,
      a11yPreventWindowsHighContrastOverride: true,
      a11yStoreFinderFocusOnBackButton: true,
      a11yStoreFinderListItemFocus: true,
      a11yFixSearchBoxDoubleFocus: true,
      a11yRestoreFocusOnNgSelect: true,
      a11yQuickOrderResetFocus: true,
      a11yCouponNotificationChannelsLinkStyling: true,
      a11yAddToWishListBtnMargin: true,
      a11yProductListItemNameMargin: true,
    }),
  ],
})
export class SpartacusFeaturesModule {}
